import { useEffect, useState, useRef } from "react";
import "./CancelOrder.css";
import { X, CircleAlert } from "lucide-react";
import ApiService from "../../components/Api_services";
import { useSelector } from "react-redux";

const CancelOrder = ({ orderId, onSuccess, onClose, orderNo }) => {
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const [reason, setReason] = useState("");
  const [fieldError, setFieldError] = useState(false);
  const modalRef = useRef(null);
  const salesman_id = useSelector((state) => state.auth.user?.salesman_id);

  const handleCancel = async () => {
    setFieldError(false);
    if (!reason.trim()) {
      setFieldError(true);
      setError("Cancel reason is required.");
      return;
    }
    try {
      setLoading(true);
      setError(null);
      const cancel_by = salesman_id ? "Salesman" : "Customer";
      const response = await ApiService.cancelOrders(
        orderId,
        cancel_by,
        reason,
      );

      if (response.status) {
        window.location.reload();
        setTimeout(() => {
          if (onSuccess) {
            onSuccess();
          }
        }, 1500);
      } else {
        setError(response.message || "Failed to cancel order");
        setLoading(false);
      }
    } catch (err) {
      console.error("Error cancelling order:", err);
      setError("An error occurred. Please try again.");
      setLoading(false);
    }
  };

  return (
    <div className="cancelorder_v2">
      <div className="cancelorder-content_v2" ref={modalRef}>
        <div className="cancelorder-title-container_v2">
          <div className="cancelorder-title_v2">
            <strong>Cancel Order</strong>
          </div>

          <button className="coclose-button_v2" onClick={onClose}>
            <X />
          </button>
        </div>

        <div className="cancelorder-main_v2">
          <div className="cancelorder-label_v2">
            You are about to cancel for <span>{orderNo} order</span>.
          </div>

          <div className="cancelorder-warning_v2">
            <CircleAlert size={20} color={"#e7000b"} />
            This action cannot be undone.
          </div>

          <div className="cancelorder-reason_v2">
            Cancellation Reason <span style={{ color: "red" }}>*</span>
          </div>
          <textarea
            className="cancelorder-reason-input_v2"
            type="text"
            value={reason}
            onChange={(e) => {
              setReason(e.target.value.slice(0, 100));
              setFieldError(false);
              setError(null);
            }}
            placeholder="Please provide the reason for cancelling this order..."
            rows={5}
            disabled={loading}
          />
          {error && <div className="error-message_v2">{error}</div>}
        </div>

        <div className="cancelorder-sub_v2">
          <button className="co-no_v2" onClick={onClose} disabled={loading}>
            Back
          </button>

          <button
            className="co-yes_v2"
            onClick={handleCancel}
            disabled={loading}
          >
            {loading ? "Processing..." : "Confirm Cancellation"}
          </button>
        </div>
      </div>
    </div>
  );
};

export default CancelOrder;
